define( function() {
	return window.location;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/ajax/var/location.js